export default "__VITE_ASSET__d281632a__"